/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ToothChartTab/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import SubMenuTab from 'DesignSystem/SubMenuTab/index'



/** @type {import('Simple/types.js').View} */
export default function ToothChartTab({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Images/Tabs/ToothChartTab"
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
  return (<React.Fragment
>
<SubMenuTab
  viewPath={`${viewPath}/SubMenuTab`}
 text="Tooth chart"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, '../../ActiveTab/ToothChart'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, '../../ActiveTab/ToothChart'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, '../../ActiveTab/ToothChart'))}
 size="medium"
/>
{children}
</React.Fragment>)
}